export default __webpack_public_path__ + "static/media/ic_cotizador_medicamentos.86806ff7.svg";